import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footer from "../layouts/Footerthree";
import Content from "../sections/Finance/InvestContent";
import Download from "../layouts/App";

const Invest = () => {
  return (
    <Fragment>
      <Helmet>
        <title>
          Buy Home For Less | Can you invest in Thailand
        </title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: "Can you invest in Thailand" }} />

      <Content />
      <Download />
      <Footer />
    </Fragment>
  );
};

export default Invest;
